import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'

export default class TextImageVariant extends Module {
  ready (app) {
    const WRAPPERS = document.querySelectorAll('.mtt-text-image-variant')
    if (WRAPPERS.length > 0) {
      for (let i = 0; i < WRAPPERS.length; i++) {
        this.createSwiper(WRAPPERS[i])
      }
    }
  }

  createSwiper (WRAPPER) {
    const SWIPER_WRAPPER = WRAPPER.querySelector('.swiper-container')
    if (SWIPER_WRAPPER == null) {
      return
    }
    const SWIPER_PAGINATION_TEXT = WRAPPER.querySelector('.mtt-text-image-variant__pagination-active-text')
    const SWIPER_PAGINATION = WRAPPER.querySelector('.swiper-pagination')
    const PAGINATION_IMAGES = JSON.parse(SWIPER_PAGINATION.getAttribute('data-pagination-images'))
    const SLIDES = WRAPPER.querySelectorAll('.swiper-slide')
    let initialSlide = 0

    if (SLIDES.length > 0) {
      for (let i = 0; i < SLIDES.length; i++) {
        if (SLIDES[i].className.indexOf('set-as-first') !== -1) {
          initialSlide = i
          break
        }
      }
    }

    const SWIPER = new Swiper(SWIPER_WRAPPER, {
      init: false,
      slidesPerView: 1,
      speed: 400,
      spaceBetween: 0,
      freeMode: false,
      watchOverflow: true,
      preloadImages: false,
      lazy: true,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (i, className) {
          return `<div class="${className} toggle object-fit"><img src="${PAGINATION_IMAGES[i].src}" /></div>`
        }
      },
      observer: true,
      observeParents: true,
      initialSlide: initialSlide
    })

    if (SWIPER_PAGINATION_TEXT) {
      SWIPER.on('slideChange', () => {
        SWIPER_PAGINATION_TEXT.innerHTML = PAGINATION_IMAGES[SWIPER.activeIndex].name
      })
      SWIPER.on('init', () => {
        SWIPER_PAGINATION_TEXT.innerHTML = PAGINATION_IMAGES[SWIPER.activeIndex].name
      })
    }

    SWIPER.init()
  }
}
